import * as ActionTypes from './blogActionType';

const initialState = {
  isLoading: false,
  isDetailLoading: false,
  detailLoadFailed: false,
  detailSlug: null,
  relatedSlug: null,
  posts: [],
  currentBlog: null,
  relatedBlogs: [],
};

export const blogReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_BLOGS:
      return { ...state, isLoading: true };
    case ActionTypes.GET_BLOGS_FAILURE:
      return { ...state, isLoading: false };
    case ActionTypes.GET_BLOGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        posts: action?.payload?.data || [],
      };

    case ActionTypes.GET_BLOG:
      return {
        ...state,
        isDetailLoading: true,
        detailLoadFailed: false,
        currentBlog: null,
        detailSlug: action.payload?.slug || null,
      };
    case ActionTypes.GET_BLOG_FAILURE:
      if (action.payload?.slug && action.payload.slug !== state.detailSlug) {
        return state;
      }
      return { ...state, isDetailLoading: false, detailLoadFailed: true };
    case ActionTypes.GET_BLOG_SUCCESS: {
      if (action.payload?.slug && action.payload.slug !== state.detailSlug) {
        return state;
      }
      const currentBlog = action?.payload?.data || null;
      return {
        ...state,
        isDetailLoading: false,
        detailLoadFailed: !currentBlog,
        currentBlog,
      };
    }

    case ActionTypes.GET_RELATED_BLOGS:
      return {
        ...state,
        relatedBlogs: [],
        relatedSlug: action.payload?.slug || null,
      };
    case ActionTypes.GET_RELATED_BLOGS_FAILURE:
      if (action.payload?.slug && action.payload.slug !== state.relatedSlug) {
        return state;
      }
      return { ...state, relatedBlogs: [] };
    case ActionTypes.GET_RELATED_BLOGS_SUCCESS:
      if (action.payload?.slug && action.payload.slug !== state.relatedSlug) {
        return state;
      }
      return {
        ...state,
        relatedBlogs: action?.payload?.data || [],
      };

    case ActionTypes.CLEAR_CURRENT_BLOG:
      return {
        ...state,
        currentBlog: null,
        relatedBlogs: [],
        detailLoadFailed: false,
        detailSlug: null,
        relatedSlug: null,
      };

    default:
      return state;
  }
};
